module.exports = __webpack_public_path__ + "img/ArrowHLink14.28a6dc67.svg";